import Claims from "./Claims";

export default Claims;
